<template>
  <div class="app-main-content">
    <sea-edi-view />
  </div>
</template>

<script>

import SeaEdiView from '@/views/cargo/v0/SeaImport/SeaEdiModule/components/SeaEdiView'
export default {
  name: 'SeaEdiModule',
  components: { SeaEdiView }
}
</script>
